import { fetcherThrows, useAuthFetch } from "matsuri-hooks"
import { preload } from "swr"
import {
    listPendingTransactions,
    ListPendingTransactionsResponse
} from "../endpoints/m2m-core.v1"

export const usePendingTransactions = (
    token: string,
    page: number,
    itemsPerPage: number
) => {
    const endpoint = listPendingTransactions
    return useAuthFetch<ListPendingTransactionsResponse>(
        token,
        endpoint({ page, itemsPerPage }),
        { swrConfig: { suspense: true } }
    )
}

export const usePendingTransactionsWithoutSuspense = (
    token: string,
    page: number,
    itemsPerPage: number
) => {
    const endpoint = listPendingTransactions
    return useAuthFetch<ListPendingTransactionsResponse>(
        token,
        endpoint({ page, itemsPerPage }),
        {}
    )
}

export const preloadPendingTransactions = (
    token: string,
    page: number,
    itemsPerPage: number
) => {
    const url = listPendingTransactions({ page, itemsPerPage })
    return preload({ url, token }, (key: { url: string; token: string }) =>
        fetcherThrows(key.url, { token: key.token })
    )
}
